(function (angular, videoPlayer, _) {
  "use strict";

  angular.module("Toyota.Legacy").service("galleryModule", function () {
    function init() {
      attachEvents();
    }

    function attachEvents() {
      var $accessoriesCarousel = angular.element(".accessories-content .carousel");
      var $accessoriesCarouselMenu = angular.element("#accessories-menu-desktop");

      angular.element(".gallery-item a").on("click", function (ev) {
        ev.preventDefault();
        // eslint-disable-next-line consistent-this
        var el = this;

        playItem(el, function () {
          showPlayPane(el);
        });
      });

      angular.element(".gallery-player-pane .close-player-pane").on("click", function (ev) {
        ev.preventDefault();
        closePlayPane(angular.element(this).parents(".gallery-player-pane:first"));
        angular.element(".gallery-player-pane.active").removeClass("active");
        angular.element(".thumbnail a").removeClass("active");
      });

      angular.element(".list-tab a[data-toggle='tab']").on("shown.bs.tab", function () {
        var str = angular.element(this).html() + ' <span class="caret"></span>';
        angular.element(".list-menu-mobile button.dropdown-toggle").html(str);
      });

      // Update the accessories carousel to display the first in the list
      $accessoriesCarouselMenu.find(".tab-name").on("click", function () {
        var target = angular.element(this).attr("href").replace("#", "");
        var $targetSelector = angular.element("#" + target);
        var slideTo = $targetSelector
          .find(".accessories-item:first-child")
          .find(".gallery-image-item")
          .attr("data-slide-to");
        var slideToNum = parseFloat(slideTo);
        $accessoriesCarousel.carousel(slideToNum);
      });

      angular.element(".collapse").on("shown.bs.collapse", function () {
        angular.element(this).find(".thumbnail .image").prop("class", "image");
      });

      angular.element('a[data-toggle="tab"]').on("shown.bs.tab", function () {
        angular.element(this.hash).find(".thumbnail .image").prop("class", "image");
      });
    }

    function loadSharethis() {
      window.switchTo5x = false;
      // eslint-disable-next-line no-underscore-dangle
      window.__st_loadLate = true;

      $.getScript("https://ws.sharethis.com/button/buttons.js", function () {
        window.stLight.options({
          publisher: "301b2958-e4c6-4d43-aea0-ef67534392a1",
        });
      });
    }

    function reloadSharethis() {
      if (window.stlib) {
        window.stlib.cookie.deleteAllSTCookie();
      }

      angular.element('[src*="sharethis.com"], [href*="sharethis.com"]').remove();
      window.stLight = undefined;
      loadSharethis();
    }

    function playItem(el, complete) {
      var $el = angular.element(el);
      if (!$el.hasClass("active")) {
        var row = $el.parents(".gallery-items-pane:first");
        var playPane = row.prev(".gallery-player-pane");
        if ($el.data("itemType") === "video") {
          playVideo(el, playPane);
        } else {
          playImage(el, playPane);
        }

        angular.element(".thumbnail a").removeClass("active");
        angular.element(".gallery-player-pane.active").removeClass("active");
        $el.addClass("active");
        reloadSharethis();
        if (complete) {
          complete();
        }
      }
    }

    function playVideo(el, playPane) {
      var $el = angular.element(el);

      if (!$el.hasClass("active")) {
        var playerContainer = playPane.find(".player-container");

        // clean everything first
        playerContainer.empty();

        // unless playerContainer.data("currentPlayer") is "video"
        var videoPlayerData = $el.data();

        // rendering the player
        var videoHTML = videoPlayer.renderVideoPlayer(videoPlayerData);

        // appending to the dom
        playerContainer.html(videoHTML);

        // starting the brightcove experience
        videoPlayer.brightCoveBootstrap();

        // set as a current playing
        playerContainer.data("currentPlayer", "video");

        // rendering the share buttons
        var shareButtons = videoPlayer.render({
          template: "tmpl-video-player-share-buttons",
          // eslint-disable-next-line id-denylist
          data: videoPlayerData,
        });

        // adding share buttons
        playerContainer.find(".video-info").prepend(shareButtons);
      }
    }

    function playImage(el, playPane) {
      var playerContainer = playPane.find(".player-container");
      var compiled = _.template(angular.element("#tmpl-image-player").html());

      var info = {
        source: angular.element(el).data("imageSrc"),
        imageTitle: angular.element(el).data("imageTitle"),
        shareUrl: angular.element(el).data("shareUrl"),
        imageDescription: angular.element(el).data("imageDescription"),
        imageDisclaimers: decodeURI(angular.element(el).data("imageDisclaimers")),
      };

      playerContainer.html(compiled(info));
      playerContainer.data("currentPlayer", "image");
    }

    function resizePane(el) {
      angular.element(el).width("100%");
    }

    function closePlayPane(pane, complete) {
      var $pane = angular.element(pane);
      $pane.slideUp({
        duration: 200,
        complete: complete,
        always: function () {
          $pane.find(".player-container").empty();
        },
      });
    }

    function openPlayPane(pane, complete) {
      resizePane(pane);
      angular.element(pane).slideDown({
        duration: 300,
        complete: complete,
      });
    }

    function showPlayPane(el, complete) {
      var row = angular.element(el).parents(".gallery-items-pane:first");
      var playPane = row.prev(".gallery-player-pane");
      row.prev(".gallery-player-pane").addClass("active");
      if (!playPane.is(":visible")) {
        if (angular.element(".gallery-player-pane:visible").length > 0) {
          closePlayPane(".gallery-player-pane:visible", function () {
            openPlayPane(playPane, complete);
          });
        } else {
          openPlayPane(playPane, complete);
        }
      } else if (complete) {
        complete();
      }
    }

    return {
      init: init,
    };
  });
})(window.angular, window.videoPlayer, window._);
